import { motion } from "framer-motion";
import { forwardRef } from "react";
import { Checkmark } from "../svgs";

export const AnimatedList = forwardRef<HTMLDivElement, {
    title: string;
    items: string[];
    hasCheckmarks: boolean;
    inView: boolean;
}>(({ title, items, hasCheckmarks, inView }, ref) => (
    <motion.div
        ref={ref}
        initial={{ opacity: 0, x: -100 }}
        animate={{
            opacity: inView ? 1 : 0,
            x: inView ? 0 : -100
        }}
        transition={{ duration: 0.5 }}
        className="text-center"
    >
        <h2 className="text-2xl font-bold text-white my-4">
            {title}
        </h2>
        <ul className="space-y-3 inline-flex flex-col items-start text-left mx-auto">
            {items.map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                    {hasCheckmarks && Checkmark}
                    <span className="text-white text-1xl leading-relaxed">
                        {item}
                    </span>
                </li>
            ))}
        </ul>
    </motion.div>
));